import config from './config';

export interface ExtendedRequest extends RequestInit {
    query?: { [ key: string ]: any };
    body?: any;
}

export default (url: string, options: ExtendedRequest = {}) => {
    options.credentials = 'include';

    if(!options){
        return fetch(url, options);
    }

    if(!options.headers){
        options.headers = new Headers();
    }

    if(config.ApiVersion){
        (<Headers>options.headers).append('ver', config.ApiVersion);
    }

    //Translate a query param object to a query string to paste after the url
    if(options.query){
        const query = Object.keys(options.query)
            .filter(k => options.query && options.query[k] !== undefined && options.query[k] !== '')
            .map(k => options.query ? `${encodeURIComponent(k)}=${encodeURIComponent(options.query[k])}` : '')
            .join('&');

        delete options.query;

        url = `${url}?${query}`;
    }

    //Automaticaly convert a body object to a stringified json and add the correct header
    if(options.body && typeof(options.body) === 'object'){
        (<Headers>options.headers).append('Content-Type', 'application/json');

        options.body = JSON.stringify(options.body);
    }

    return fetch(url, options);
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./node_modules/sensejs/core/fetch-extension.ts